var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7088 6.49922L11.3669 9.85235C11.6519 10.6442 11.77 11.9705 10.5425 13.6023C10.4567 13.7171 10.3471 13.812 10.2212 13.8805C10.0953 13.9489 9.95613 13.9895 9.81316 13.9992C9.78941 13.9992 9.76628 13.9992 9.74253 13.9992C9.61113 13.9992 9.48101 13.9734 9.35961 13.9231C9.23821 13.8728 9.12792 13.799 9.03503 13.7061L6.01878 10.6867L3.35441 13.353C3.26059 13.4468 3.13334 13.4995 3.00066 13.4995C2.86797 13.4995 2.74073 13.4468 2.64691 13.353C2.55309 13.2592 2.50038 13.1319 2.50038 12.9992C2.50038 12.8665 2.55309 12.7393 2.64691 12.6455L5.31316 9.9811L2.29441 6.96235C2.19518 6.863 2.11799 6.74387 2.06786 6.61271C2.01773 6.48155 1.99578 6.3413 2.00344 6.2011C2.01111 6.06089 2.04821 5.92387 2.11234 5.79896C2.17647 5.67405 2.26619 5.56404 2.37566 5.4761C3.96441 4.19422 5.48503 4.4461 6.15066 4.65485L9.50066 1.29297C9.59352 1.20009 9.70377 1.12641 9.82511 1.07614C9.94645 1.02587 10.0765 1 10.2078 1C10.3392 1 10.4692 1.02587 10.5906 1.07614C10.7119 1.12641 10.8222 1.20009 10.915 1.29297L14.7082 5.08547C14.8956 5.27291 15.001 5.52712 15.0011 5.79222C15.0012 6.05732 14.8961 6.31162 14.7088 6.49922Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/Pinned.7e534b6ee10a1abb4157f0c95b7e299b.svg";
export { ForwardRef as ReactComponent };